// Parse a "H:MM" or "HH:MM" duration string to decimal hours.
// Returns the numeric value (e.g. "02:30" → 2.5) or null when the format is invalid.
export function parseLengthText(text) {
  if (/^[0-9]+:[0-5][0-9]/.test(text)) {
    const timearray = text.split(':');
    return Number(timearray[0]) + Number(timearray[1].substr(0, 2)) / 60;
  }
  return null;
}

export function lengthToText(length) {
  const currenthours = parseInt(length);
  const currentminutes = parseInt((length - currenthours) * 60);
  const currentminutestext = currentminutes < 10 ? '0'.concat(currentminutes.toString()) : currentminutes.toString();
  const texttime = currenthours.toString().concat(':', currentminutestext);
  return texttime;
}